import type { SupportSessionRefusalKind } from '@/context/SupportSessionContext'
import { EyeSlashIcon } from '@heroicons/react/24/outline'

import { Card, CardContent, CardHeader, CardTitle } from '@droidmap/frontend-ui'

/**
 * A page a support session's services refused to show (droidmap#2926): most
 * often another of the user's organisations, outside the one the session
 * covers. Said plainly, so it does not read as the page not existing, which
 * is what the 403 would otherwise become.
 */
export default function OutsideSupportSession({
  kind,
}: {
  kind: SupportSessionRefusalKind
}) {
  return (
    <div className="flex items-center justify-center">
      <Card className="w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 text-warning">
            <EyeSlashIcon aria-hidden />
          </div>
          <CardTitle className="text-2xl">
            {kind === 'wrong_org'
              ? 'Outside this support session'
              : 'Not available in a support session'}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-text/75 mb-6">
            {kind === 'wrong_org'
              ? 'This page is outside the organisation this support session covers. Start a session in its organisation from the admin console to see it.'
              : 'A support session cannot open this page.'}
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
